import { API_BASE as API, authHeaders } from "./api";

// My Wishes (backend/app/main.py "MY WISHES"). The heart writes here rather
// than to /wishlist, because POST /wishes is what records `price_at_wish` —
// the baseline behind "Dropped Ksh X since you wished". A wish saved through
// the older endpoint has no baseline and shows no drop, so there is exactly
// one write path.
//
// Every mutation returns the whole list, like the cart's endpoints, so one
// round trip reconciles the client.
//
// A 404/405 means this backend predates the endpoints — flagged as
// `unavailable` so the caller can fall back to local storage instead of
// treating it as a real failure. That distinction matters here: production
// is many commits behind the frontend (CLAUDE.md, "Frontend/backend deploy
// gap"), so "not deployed yet" is a live case, not a hypothetical.
const request = async (path, { method = "GET", token, body } = {}) => {
  const res = await fetch(`${API}/wishes${path}`, {
    method,
    headers: { ...(body ? { "Content-Type": "application/json" } : {}), ...authHeaders(token) },
    ...(body ? { body: JSON.stringify(body) } : {}),
    cache: "no-store",
  });
  if (!res.ok) {
    const err = new Error(`Wishes ${method} ${path} failed: ${res.status}`);
    err.status = res.status;
    err.unavailable = res.status === 404 || res.status === 405;
    throw err;
  }
  return res.json();
};

// The wish rows, each carrying its product plus price/stock/count context.
export const fetchWishes = (token) => request("", { token });

export const addWish = (token, productId, { variantId = null, note = null } = {}) =>
  request("", { method: "POST", token, body: { product_id: productId, variant_id: variantId, note } });

export const removeWish = (token, productId) => request(`/${productId}`, { method: "DELETE", token });

export const updateWish = (token, productId, fields) =>
  request(`/${productId}`, { method: "PATCH", token, body: fields });

export const mergeWishes = (token, productIds) =>
  request("/merge", { method: "POST", token, body: { product_ids: productIds } });
